import { gql, useQuery } from '@apollo/client'
import moment from 'moment'
import { useMemo } from 'react'

import { useDateFilter } from '../../../dateFilter'
import { useGroupFilter } from '../../../groupFilter'
import useListLocationGroupDeliveryKpis, {
  listLocationGroupDeliveryKpisConfigs,
} from '../common/delivery/useListLocationGroupDeliveryKpis'

interface IDataTpye {
  customizedSummaryDelivery: {
    nodes: {
      totalOrderCount: number
      sumSubtotal: number
      completedDisputeAmount: number
    }[]
  }
}

const query = gql`
  query customDeliveryKpi(
    $iEndDate: Date!
    $iStartDate: Date!
    $iLocationGroupIds: [Int]!
  ) {
    customizedSummaryDelivery(
      iEndDate: $iEndDate
      iStartDate: $iStartDate
      iFilter: { location_group_ids: $iLocationGroupIds }
    ) {
      nodes {
        totalOrderCount
        sumSubtotal
        completedDisputeAmount
      }
    }
  }
`

export const bibibopListLocationGroupDeliveryKpisConfigs = {
  ...listLocationGroupDeliveryKpisConfigs,
  totalOrderCount: 'number',
  sumSubtotal: 'price',
  completedDisputeAmount: 'price',
} as const

const YESTERDAY = moment().subtract(1, 'day')

const useBibibopListLocationGroupDeliveryKpis = () => {
  const { data, loading } = useListLocationGroupDeliveryKpis()
  const { startDate, endDate: filterEndDate } = useDateFilter()
  const { groupFilter } = useGroupFilter()
  const endDate = useMemo(
    () =>
      moment(filterEndDate, 'YYYY-MM-DD').isAfter(YESTERDAY)
        ? YESTERDAY.format('YYYY-MM-DD')
        : filterEndDate,
    [filterEndDate],
  )
  const { data: customData, loading: customLoading } = useQuery<IDataTpye>(
    query,
    {
      variables: {
        iStartDate: startDate,
        iEndDate: endDate,
        iLocationGroupIds: groupFilter?.ids,
      },
      skip: !startDate || !endDate || !groupFilter,
    },
  )

  return {
    data: useMemo(() => {
      const deliveryData = customData?.customizedSummaryDelivery.nodes[0]

      if (!data || !deliveryData) return null

      return {
        ...data,
        ...deliveryData,
      }
    }, [data, customData]),
    loading: loading || customLoading,
  }
}

export default useBibibopListLocationGroupDeliveryKpis
